<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">{{ $t('자기소개서') }}</h1>
    </div>
    <div class="body">
      <v-form ref="form">
        <template v-for="(item, i) in selfIntro">
          <v-row class="mt-8" v-if="item.yn === 'Y'" :key="'selfIntro' + i">
            <v-col cols="12" style="font-weight: bold;">
              {{ $t(item.value) }}</v-col
            >
            <v-col cols="12" class="mt-2">
              <template v-if="isReadonly">
                <v-row>
                  <!-- style="box-shadow: none !important;" -->
                  <i-textarea
                    outlined
                    single-line
                    dense
                    readonly
                    auto-grow
                    :counter="item.limit"
                    v-model="item.desc"
                  ></i-textarea>
                </v-row>
              </template>
              <template v-else>
                <i-textarea
                  :label="getLabel(item.min, item.limit)"
                  v-model="item.desc"
                  outlined
                  single-line
                  dense
                  :counter="item.limit"
                  validate-on-blur
                  :rules="[
                    rules.required(item.name),
                    rules.maxlength(item.name),
                    rules.minlength(item.name),
                  ]"
                  :disabled="item.limit == 0"
                  @blur="save(i)"
                ></i-textarea>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    selfIntro: [],
    alert: false,
  }),
  methods: {
    setting: function() {
      this.selfIntro = [];
      for (let i = 1; i <= 10; i++) {
        let preName = 'selfIntro' + i;
        let lengthNm = preName + 'Length';
        let ynNm = preName + 'Yn';
        let MinlengthNm = preName + 'MinLength';
        let obj = {
          value: this.template[preName] ?? '',
          limit: this.template[lengthNm] ?? 0,
          min: this.template[MinlengthNm] ?? 0,
          yn: this.template[ynNm] ?? 'N',
          name: preName,
          desc: this.desc(preName),
        };

        this.selfIntro.push(obj);
      }
    },
    desc: function(preName) {
      let desc = '';

      if (
        this.info &&
        this.info.selfIntros &&
        this.info.selfIntros.length > 0
      ) {
        this.info.selfIntros.forEach(function(v) {
          if (v.id.cvColumn === preName) desc = v.selfIntro;
        });
      }

      return desc;
    },
    replaceBr: function(contents) {
      if (contents == undefined || !contents) {
        return '';
      }

      contents = contents.replace(/\r\n/gi, '<br />');
      contents = contents.replace(/\n/gi, '<br />');

      return contents;
    },
    getLabel: function(min, max) {
      return this.$t('입력 가능 글자 수 : ') + `${min}` + ' ~ ' + `${max}`;
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function(i) {
      const id = {
        annoId: this.$route.params.annoId,
        cvColumn: this.selfIntro[i].name,
      };
      const p = {
        id: id,
        selfIntro: this.selfIntro[i].desc,
      };

      this.$emit('save', p, 'selfIntro');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('SELF INTRO SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.selfintro {
  padding: 12px !important;
  border-radius: 2px;
  border: 1px solid #999999;
}
</style>
